module.exports = __webpack_public_path__ + "img/bannerLabel3Blue.c230cec0.png";